// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-input-length-counter[data-v-39d9c469]{overflow:hidden}.form-input-length-counter__label[data-v-39d9c469]{color:#949bac}.form-input-length-counter__counter[data-v-39d9c469]{float:right}.form-input-length-counter--exceeded .form-input-length-counter__counter[data-v-39d9c469]{color:#f71f40}", ""]);
// Exports
module.exports = exports;
